import Switch from "@mui/material/Switch"
import React, {useContext, useEffect} from "react"
import {DataContext} from "../../../context/DataContextProvider"
import {getMerkmal} from "../../../../anwendungskonfigurator/misc/widget-functions"


const SwitchToArrayWidget = ({widget, value = [], onValueChange}) => {
    const {updateData} = useContext(DataContext)
    const {getDataFromPointer} = useContext(DataContext)
    const {disabled} = widget
    const key = widget.tag
    const safeValue = Array.isArray(value) ? value : []
    const show = getDataFromPointer(widget.subtext)?.includes(key) ?? true
    const onTriggerSwitch = () => {
        onValueChange(
            safeValue.includes(key)
                ? safeValue.filter(entry => entry !== key)
                : [...safeValue, key],
        )
    }

    useEffect(() => {
        const merkmal = getMerkmal(widget)
        widget.text && updateData(safeValue.includes(key), widget.text)
        if (widget.subtext && merkmal) {
            updateData(show && safeValue.includes(key), merkmal.pointer + key)
        }
    }, [value])

    return (
        show && (
            <Switch
                sx={{m: 1}}
                checked={safeValue.includes(key)}
                onChange={onTriggerSwitch}
                disabled={disabled}
                defaultChecked={!disabled}
            />
        )
    )
}

export default SwitchToArrayWidget
